(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[521],{

/***/ 5706:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about",
      function () {
        return __webpack_require__(512);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* reexport */ Box; },
  "e": function() { return /* reexport */ SmallBox; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/atoms/Box/Box.tsx

var Box = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "md:w-10/12 px-8 py-6 rounded-3xl glass-light dark:glass-dark mb-6 drop-shadow-lg hover:drop-shadow-2xl transition-all",
        children: children
    });
};
var SmallBox = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: " px-8 py-6 rounded-3xl glass-light dark:glass-dark mb-6 drop-shadow-lg hover:drop-shadow-2xl transition-all",
        children: children
    });
};


;// CONCATENATED MODULE: ./components/atoms/Box/index.ts



/***/ }),

/***/ 512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ about; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/atoms/Container/index.ts + 1 modules
var Container = __webpack_require__(4232);
// EXTERNAL MODULE: ./layout/Layout/index.ts + 17 modules
var Layout = __webpack_require__(2092);
;// CONCATENATED MODULE: ./data/skills.json
var skills_namespaceObject = JSON.parse('{"Languages":["JavaScript","TypeScript","php","Java","C++","csharp","Python","HTML5","CSS3","Kotlin","swift"],"Frameworks:":["React",{"alt":"Next.js","icon":"nextdotjs"},{"alt":"Node.js","icon":"nodedotjs"},{"alt":"React_Native","icon":"react","backgroundColor":"#424242"},"Expo","Express","Redux","wordpress","flask","graphql","Sequelize",{"alt":"Material Design","icon":"mui"},"antdesign","Bootstrap","TailwindCSS"],"OS":["Android","ios","windows","macos","linux"],"Database":["mysql","MicrosoftSQLServer","mongodb","PostgreSQL","SQLite","firebase"],"Cloud Provider":["GoogleCloud","AmazonAWS","Netlify","Vercel","Heroku","Cloudflare"],"Other":["Docker","Kubernetes","Stripe","Webpack","JetBrains","Passport","VisualStudioCode"]}');
// EXTERNAL MODULE: ./node_modules/simple-icons/index.js
var simple_icons = __webpack_require__(9467);
var simple_icons_default = /*#__PURE__*/__webpack_require__.n(simple_icons);
;// CONCATENATED MODULE: ./utils/index.ts
function iconify() {
    var input = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var replacers = [
        {
            in: /\+/g,
            out: "plus"
        },
        {
            in: /\./g,
            out: "-dot-"
        },
        {
            in: /&/g,
            out: "-and-"
        },
        {
            in: " ",
            out: ""
        },
        {
            in: "_",
            out: ""
        }, 
    ];
    var output = input.toLowerCase();
    replacers.forEach(function(replacer) {
        output = output.replace(replacer.in, replacer.out);
    });
    return output;
}

// EXTERNAL MODULE: ./node_modules/react-tooltip/dist/index.es.js + 3 modules
var index_es = __webpack_require__(8735);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
;// CONCATENATED MODULE: ./data/school.json
var school_namespaceObject = JSON.parse('[{"institute":{"name":"Sheridan College","logo":"https://media-exp1.licdn.com/dms/image/C560BAQGySRaDp-eCcg/company-logo_200_200/0/1628089623805?e=1651708800&v=beta&t=MyUS9ndNEr7IRmxjQLMAbAEu15xVV-RVM0rk6e17kvo","url":"https://www.sheridancollege.ca/"},"course":"Computer Science","date":"","technologies":["Java","C#","Kotlin","Swift","SQL | NoSQL","Data Structures & Algorithms"]},{"institute":{"name":"C-DAC","logo":"https://media-exp1.licdn.com/dms/image/C4E0BAQHsh6b7kt7tEQ/company-logo_200_200/0/1578294217220?e=1651708800&v=beta&t=_gzE9RNe-bOVDUoOPnD2PMZ7DYZfcl5esawfE0hVeH0","url":"https://www.cdac.in/"},"course":"Core (object-oriented programming) C and C++","date":"","technologies":["C","C++"]}]');
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/atoms/Box/index.ts + 1 modules
var Box = __webpack_require__(9399);
;// CONCATENATED MODULE: ./components/molecules/School/School.tsx



var School = function(param) {
    var institute = param.institute, course = param.course, date = param.date, technologies = param.technologies;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex gap-4 items-center justify-center",
                children: [
                    institute.logo && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                        src: institute.logo,
                        alt: institute.name,
                        width: 64,
                        height: 64,
                        className: "rounded-md"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full mb-2 flex flex-col justify-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "font-bold",
                                        children: course
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: date
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: institute.url ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: institute.url,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    className: "underlined relative",
                                    children: institute.name
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: institute.name
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "text-sm mt-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "Course Contents: "
                    }),
                    technologies.join(", ")
                ]
            })
        ]
    });
};


;// CONCATENATED MODULE: ./components/molecules/School/index.ts


;// CONCATENATED MODULE: ./components/organisms/Education/Education.tsx



var Education = function(param1) {
    var education = param1.education;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: education.map(function(param, index) {
            var course = param.course, date = param.date, institute = param.institute, technologies = param.technologies;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("flex transition-all transform-gpu md:hover:-translate-y-4", {
                    "justify-end": index % 2 !== 0
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(School, {
                    course: course,
                    date: date,
                    institute: institute,
                    technologies: technologies
                })
            }, course);
        })
    });
};


;// CONCATENATED MODULE: ./components/organisms/Education/index.ts


;// CONCATENATED MODULE: ./pages/about/index.tsx










var wrapper = function() {
    var sk = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return sk.map(function(v) {
        var ic = simple_icons_default().Get(typeof v === "string" ? iconify(v) : iconify(v.icon)) || {
            title: v,
            hex: "424242",
            component: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: "Cancel"
            })
        };
        return {
            alt: v.alt || v || ic.title,
            backgroundColor: v.backgroundColor || "#" + ic.hex,
            icon: ic.component || /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                role: "img",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg",
                height: "100%",
                width: "100%",
                xmlnsXlink: "http://www.w3.org/1999/xlink",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: ic.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: ic.path,
                        fill: "white"
                    })
                ]
            })
        };
    });
};
var wrappedSkills = {};
Object.getOwnPropertyNames(skills_namespaceObject).forEach(function(type) {
    wrappedSkills[type] = wrapper(skills_namespaceObject[type]);
});
var iobj = {};
Object.values(wrappedSkills).forEach(function(oarr) {
    oarr.forEach(function(param) {
        var backgroundColor = param.backgroundColor, alt = param.alt;
        iobj[alt] = {
            backgroundColor: backgroundColor
        };
    });
});
var AboutPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* Layout */.A, {
        title: "About Krutik Parikh, a Senior Software Engineer in the Canada",
        description: "As a passionate software developer, I create amazing websites and web apps to make the internet a better place.",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "headline text-3xl md:text-5xl lg:text-6xl mt-8",
                        children: "Hey, I'm Krutik Parikh"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "font-bold text-xl md:text-2xl mt-2",
                        children: "Senior Software Engineer from Canada"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid md:grid-cols-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-span-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mt-8",
                                        children: "As a passionate Fullstack developer, I create amazing websites and web apps to make the internet a better place. I am an advocate for web performance and accessibility as well as a JAMstack enthusiast with experience in serverless technologies."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "my-4",
                                        children: [
                                            "I am ",
                                            new Date().getFullYear() - 1999,
                                            " years young and have been a web developer for as long as I can think. The technologies I work with are JavaScript with a focus on the frameworks React.js, Next.js, Node, and Express. I use code not only to do my day-to-day job, but also to solve everyday problems I come across."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "When I am not writing code I love to spend time with my family and friends, having grown up in India \uD83C\uDDEE\uD83C\uDDF3 and living in Canada \uD83C\uDDE8\uD83C\uDDE6 without the family being here is very difficult. I have been living here in Brampton, Canada since 2017 and loved every single day since. Apart from coding, i love to cook, watch shows and Indian Movies"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "rounded",
                                    style: {
                                        width: "100%",
                                        height: "100%",
                                        position: "relative"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                        src: "/assets/profile.jpg",
                                        alt: "/assets/profile.jpg",
                                        layout: "fill",
                                        objectFit: "contain"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                        className: "mt-5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "headline mt-12 mb-4 text-4xl",
                        children: "Education"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mb-6",
                        children: "I am mostly self-taught, but here are some of the most relevant studies I have achieved:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Education, {
                        education: school_namespaceObject
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                        className: "mt-5"
                    }),
                    Object.getOwnPropertyNames(wrappedSkills).map(function(title, id) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex mt-5 flex-col",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "text-lg font-semibold",
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-2 flex flex-wrap md:flex-row gap-4",
                                    children: wrappedSkills[title].map(function(param, i) {
                                        var alt = param.alt, icon = param.icon, backgroundColor = param.backgroundColor;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex flex-col",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                "data-tip": alt.replace("_", " "),
                                                style: {
                                                    backgroundColor: backgroundColor
                                                },
                                                className: "rounded-lg transition duration-150 ease-in-out",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    style: {
                                                        backgroundColor: backgroundColor
                                                    },
                                                    className: "m-1 mr-2 w-12 h-12 relative flex justify-center items-center rounded-full text-xl uppercase",
                                                    children: icon
                                                })
                                            })
                                        }, i);
                                    })
                                })
                            ]
                        }, id);
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var about = (AboutPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [751,61,353,336,774,888,179], function() { return __webpack_exec__(5706); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);